import { render, staticRenderFns } from "./PublicSearchPaidForm.vue?vue&type=template&id=68054ad8&scoped=true&"
import script from "./PublicSearchPaidForm.vue?vue&type=script&lang=js&"
export * from "./PublicSearchPaidForm.vue?vue&type=script&lang=js&"
import style0 from "./PublicSearchPaidForm.vue?vue&type=style&index=0&id=68054ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68054ad8",
  null
  
)

export default component.exports